import {
  ORDERS_BY_PRODUCT,
  ORDERS_BY_PRODUCT_ERROR,
  CLEAN_ORDERS_BY_PRODUCT,
  CLEAN_ORDERS_BY_PRODUCT_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function ordersByProductReducer(state = initialState, action) {
  switch (action.type) {
    case ORDERS_BY_PRODUCT:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case ORDERS_BY_PRODUCT_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_ORDERS_BY_PRODUCT:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_ORDERS_BY_PRODUCT_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
